import * as angular from "angular";
import {IController, IQService, IWindowService} from "angular";
import * as _ from "lodash";
import {DataSet} from "vis-data";
import {PlanningAlertsService} from "../../../planning/services/planning-alerts.service";
import {PlanningCommonService} from "../../../planning/services/planning-coomon-service.service";
import {PlanningDialogService} from "../../../planning/services/planning-dialogs-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {VisitScheduleResourceModel} from "../../models/visit-schedule-resource.model";
import {VisitPlanModel} from "../../models/visit-plan.model";
import {VisitScheduleDayModel} from "../../models/visit-schedule-day.model";
import {
  VisitScheduleAnalysisModel,
  VisitScheduleRouteActivityAnalysisModel,
  VisitScheduleRouteAnalysisModel
} from "../../models/visit-schedule-analysis.model";
import {VisitScheduleActivityDetailsModel} from "../../models/visit-plan-route.model";
import {escapeHtml} from "../../../commons/utils/html-escape.util";

export class VisitPlanRoutesTimelineComponent implements IController {
  visitPlan: VisitPlanModel;
  visitScheduleDays: VisitScheduleDayModel[];
  from: any;
  to: any;
  allRoutes: any;
  jobs: any;
  depotsMap: any;
  mainRoutes: any;
  analysis?: VisitScheduleAnalysisModel;
  routes: any;
  queryString: any;
  draftAnalysis: any;
  draft: any;
  selectedItemId: any;
  selectedJobIds: any;
  canEdit: any;
  displayPrice: any;
  hiddenRouteIds: any;
  hideLockedRoutes?: boolean;
  inspectedStopIds: any;
  isGroupedRoutes: any;
  visibleResourceAllocationSkills: any;
  isValidateRouteVehicles: boolean;
  offset: any;
  limit: any;
  doFit: any;
  agentColorMap: { [key: string]: string };
  programTypeAliasMap: { [key: string]: string };
  resources: any[];
  onFit: Function;
  onAddStopsToRoute: Function;
  onToggleRoute: Function;
  onRouteInfoClick: Function;
  onToggleHiddenRoutes: Function;
  onRoutesChange: Function;
  onLockRouteChange: Function;
  onInspectedStopIdsChange: Function;
  onZoomActivity: Function;
  onActivitySelection: Function;
  onActivityHover: Function;
  onActivityRightClick: Function;
  onMoveItem: Function;
  onRecalcRoute: Function;
  onDeleteRoute: Function;
  onDispatchRoute: Function;
  onChangeRouteResource: Function;
  onEditRoutes: Function;
  onToggleHideLockedRoutes: Function;
  onQueryChange: Function;
  onFiltersChange: Function;
  onPaginationBrowse: Function;
  onPaginationChange: Function;

  public timeline: any;
  public maxPagesToDisplay: number = 3;

  private readonly vis: any;
  private dateAndTimeConfig: any;
  private timeFormat: any;
  private longDateFormat: string;
  private shortDateFormat: string;
  private options: any = {
    min: undefined,
    max: undefined,
    stack: undefined
  };
  private SITE_VOLUME_UNIT: string;
  private SITE_WEIGHT_UNIT: string;
  private container: any;
  private groupsDataSet: any
  private itemsDataSet: any;
  private tableHeaderDivRef: any;
  private movingItem: any;
  private $infinitySymbol: string;
  private actionsByStatus: any;

  /////////////////////////// ICONS ///////////////////////////
  private iconsUrl: any;
  private $weightIcon: any;
  private $volumeIcon: any;
  private $packageIcon: any;
  private $spotsIcon: any;
  private $accountIcon: any;
  private $branchIcon: any;
  private $programIcon: any;
  private $riskIcon: any;
  private $addressIcon: any;
  private $originalTimeWindowIcon: any;
  private $timeWindowIcon: any;
  private $barcodeIcon: any;
  private $serviceTimeIcon: any;
  private $relationIcon: any;
  private $infoIcon: any;
  private $skillsIcon: any;
  private $depotIcon: any;
  private $locationIcon: any;
  private $eyeIcon: any;
  private $goTolinkIcon: any;
  private $linkIcon: any;
  private $errorIcon: any;
  private $menuIcon: any;
  private isFirstFit: boolean = true;
  private $lockIcon: any;
  private $tripIcon: any;
  private $timeZoneIcon: any;
  public jobsMap: any;
  public selectedActivities: any[];
  public userZoneId: string;
  public timezoneOffset: number;

  // Single delegated click handler for all group-row actions, attached once on
  // `this.container` after the timeline is created. Per-cell `addEventListener`
  // calls inside `groupTemplate` previously created N new listeners on every
  // vis redraw — now each cell only carries `data-bz-action` + `data-bz-id`
  // (+ optional `data-bz-related-ids` / `data-bz-dispatched-id`) attributes.
  private readonly _onContainerClick = (event: Event) => {
    const target = event.target as Element | null;
    if (!target) return;
    const actionEl = target.closest('[data-bz-action]') as HTMLElement | null;
    if (!actionEl) return;
    const action = actionEl.dataset.bzAction;
    const id = actionEl.dataset.bzId;
    if (!action) return;
    this._onClicked().then(() => {
      if (action === 'toggle-route') {
        if (!id) return;
        const currentlyEnabled = !_.includes(this.hiddenRouteIds, id);
        this.onToggleRoute({id: id, isEnabled: !currentlyEnabled});
      } else if (action === 'go-to-dispatched') {
        const dispatchedId = actionEl.dataset.bzDispatchedId;
        if (dispatchedId) {
          this.$state.go('planning-route', {id: dispatchedId});
        }
      } else if (action === 'combine-related-routes') {
        if (!id) return;
        const relatedIdsAttr = actionEl.dataset.bzRelatedIds || '';
        const uiqRelatedRoutes = _.uniq(relatedIdsAttr.split(',').filter(Boolean));
        const routeIds = [id].concat(uiqRelatedRoutes);
        const routes = _.filter(this.allRoutes, (r: any) => _.includes(routeIds, r.id));
        this.onRoutesChange({routes: routes});
      }
    });
  };


  constructor(private $window: IWindowService, private $timeout, private $state, private $q: IQService, private confirmDialogService: ConfirmDialogService, private commonsDialogService: CommonsDialogService,
              private splitService, private planningCommonService: PlanningCommonService, private $filter, private leanPlanningConstants, private commonsService: CommonsService,
              private planningAlertsService: PlanningAlertsService, private $log, private moment, private planningDialogService: PlanningDialogService) {
    this.vis = require('vis-timeline');
    this.$infinitySymbol = '&#8734;';

    /////////////////////////// ICONS ///////////////////////////
    this.iconsUrl = {
      account: 'assets/images/icons/v2/account.svg',
      branch: 'assets/images/icons/v2/branch.svg',
      address: 'assets/images/icons/v2/location-pin.svg',
      weight: 'assets/images/icons/v2/weight.svg',
      volume: 'assets/images/icons/v2/volume.svg',
      originalTimeWindow: 'assets/images/icons/v2/calendar-outline.svg',
      timeWindow: 'assets/images/icons/v2/time-window-outline.svg',
      barcode: 'assets/images/icons/v2/barcode.svg',
      serviceTime: 'assets/images/icons/v2/timer-outline.svg',
      program: 'assets/images/icons/v2/program.svg',
      relation: 'assets/images/icons/v2/relation.svg',
      packageItem: 'assets/images/icons/v2/package-outline.svg',
      spot: 'assets/images/icons/v2/spot.svg',
      info: 'assets/images/icons/v2/info-outline.svg',
      skills: 'assets/images/icons/v2/skill.svg',
      risk: 'assets/images/icons/v2/risk.svg',
      goToLink: 'assets/images/icons/v2/open.svg',
      depot: 'assets/images/icons/v2/depot.svg',
      eye: 'assets/images/icons/v2/show.svg',
      eyeOn: 'assets/images/icons/v2/eye-on.svg',
      eyeOff: 'assets/images/icons/v2/eye-off.svg',
      location: 'assets/images/icons/v2/location-pin-outline.svg',
      link: 'assets/images/icons/v2/linked.svg',
      error: 'assets/images/icons/v2/error-outline.svg',
      menu: 'assets/images/icons/v2/menu.svg',
      locked: 'assets/images/icons/v2/lock.svg',
      unlocked: 'assets/images/icons/v2/lock-open-outline.svg',
      trip: 'assets/images/icons/v2/route.svg',
      timeZone: 'assets/images/icons/v2/time-zone.svg',
    }
    this.$accountIcon = document.createElement('IMG');
    this.$accountIcon.setAttribute("src", this.iconsUrl.account);
    this.$accountIcon.classList.add('icon', 'bringoz-icon-small', 'grey');

    this.$branchIcon = document.createElement('IMG');
    this.$branchIcon.setAttribute("src", this.iconsUrl.branch);
    this.$branchIcon.classList.add('bringoz-icon-small', 'gray');

    this.$addressIcon = document.createElement('IMG');
    this.$addressIcon.setAttribute("src", this.iconsUrl.address);
    this.$addressIcon.classList.add('icon', 'bringoz-icon-small', 'grey');

    this.$weightIcon = document.createElement('IMG');
    this.$weightIcon.setAttribute("src", this.iconsUrl.weight);
    this.$weightIcon.classList.add('icon', 'bringoz-icon-small', 'grey');

    this.$volumeIcon = document.createElement('IMG');
    this.$volumeIcon.setAttribute("src", this.iconsUrl.volume);
    this.$volumeIcon.classList.add('icon', 'bringoz-icon-small', 'grey');

    this.$originalTimeWindowIcon = document.createElement('IMG');
    this.$originalTimeWindowIcon.setAttribute("src", this.iconsUrl.originalTimeWindow);
    this.$originalTimeWindowIcon.classList.add('icon', 'bringoz-icon-small', 'grey');

    this.$timeWindowIcon = document.createElement('IMG');
    this.$timeWindowIcon.setAttribute("src", this.iconsUrl.timeWindow);
    this.$timeWindowIcon.classList.add('icon', 'bringoz-icon-small', 'grey');

    this.$programIcon = document.createElement('IMG');
    this.$programIcon.setAttribute("src", this.iconsUrl.program);
    this.$programIcon.classList.add('icon', 'bringoz-icon-small');

    this.$riskIcon = document.createElement('IMG');
    this.$riskIcon.setAttribute("src", this.iconsUrl.risk);
    this.$riskIcon.classList.add('bringoz-icon-small', 'red');

    this.$serviceTimeIcon = document.createElement('IMG');
    this.$serviceTimeIcon.setAttribute("src", this.iconsUrl.serviceTime);
    this.$serviceTimeIcon.classList.add('icon', 'bringoz-icon-small');

    this.$tripIcon = document.createElement('IMG');
    this.$tripIcon.setAttribute("src", this.iconsUrl.trip);
    this.$tripIcon.classList.add('icon', 'bringoz-icon-small', 'grey');

    this.$barcodeIcon = document.createElement('IMG');
    this.$barcodeIcon.setAttribute("src", this.iconsUrl.barcode);
    this.$barcodeIcon.classList.add('icon', 'bringoz-icon-small', 'grey');

    this.$relationIcon = document.createElement('IMG');
    this.$relationIcon.setAttribute("src", this.iconsUrl.relation);
    this.$relationIcon.classList.add('icon', 'bringoz-icon-small', 'grey');

    this.$packageIcon = document.createElement('IMG');
    this.$packageIcon.setAttribute("src", this.iconsUrl.packageItem);
    this.$packageIcon.classList.add('icon', 'bringoz-icon-small', 'grey');

    this.$spotsIcon = document.createElement('IMG');
    this.$spotsIcon.setAttribute("src", this.iconsUrl.spot);
    this.$spotsIcon.classList.add('icon', 'bringoz-icon-small', 'grey');

    this.$infoIcon = document.createElement('IMG');
    this.$infoIcon.setAttribute("src", this.iconsUrl.info);
    this.$infoIcon.classList.add('icon', 'bringoz-icon-small', 'grey');

    this.$skillsIcon = document.createElement('IMG');
    this.$skillsIcon.setAttribute("src", this.iconsUrl.skills);
    this.$skillsIcon.classList.add('icon', 'bringoz-icon-small', 'grey');

    this.$depotIcon = document.createElement('IMG');
    this.$depotIcon.setAttribute("src", this.iconsUrl.depot);
    this.$depotIcon.classList.add('icon', 'bringoz-icon-small', 'grey');

    this.$eyeIcon = document.createElement('IMG');
    this.$eyeIcon.setAttribute("src", this.iconsUrl.eyeOn);
    this.$eyeIcon.classList.add('icon', 'bringoz-icon', 'grey');

    this.$goTolinkIcon = document.createElement('IMG');
    this.$goTolinkIcon.setAttribute("src", this.iconsUrl.goTolink);
    this.$goTolinkIcon.classList.add('icon', 'bringoz-icon');

    this.$locationIcon = document.createElement('IMG');
    this.$locationIcon.setAttribute("src", this.iconsUrl.location);
    this.$locationIcon.classList.add('icon', 'bringoz-icon', 'grey');

    this.$linkIcon = document.createElement('IMG');
    this.$linkIcon.setAttribute("src", this.iconsUrl.link);
    this.$linkIcon.classList.add('icon', 'bringoz-icon', 'grey');

    this.$errorIcon = document.createElement('IMG');
    this.$errorIcon.setAttribute("src", this.iconsUrl.error);
    this.$errorIcon.classList.add('icon', 'bringoz-icon', 'grey');

    this.$menuIcon = document.createElement('IMG');
    this.$menuIcon.setAttribute("src", this.iconsUrl.menu);
    this.$menuIcon.classList.add('icon', 'bringoz-icon', 'grey');

    this.$lockIcon = document.createElement('IMG');
    this.$lockIcon.setAttribute("src", this.iconsUrl.unlocked);
    this.$lockIcon.classList.add('icon', 'bringoz-icon', 'grey');


    this.$timeZoneIcon = document.createElement('IMG');
    this.$timeZoneIcon.setAttribute("src", this.iconsUrl.timeZone);
    this.$timeZoneIcon.classList.add('bringoz-icon-small', 'gray');
  }

  $onInit() {


    this.userZoneId = this.moment.tz.guess()

    this.timezoneOffset = this.moment.tz.zone(this.userZoneId).utcOffset(this.moment().valueOf()) - this.moment.tz.zone(this.visitPlan.zoneId).utcOffset(this.moment().valueOf());

    this.dateAndTimeConfig = this.splitService.getDateAndTimeConfig();
    this.timeFormat = this.dateAndTimeConfig.time;
    this.shortDateFormat = this.dateAndTimeConfig.date;
    this.longDateFormat = this.dateAndTimeConfig.long;
    this.SITE_WEIGHT_UNIT = this.$filter('translate')(this.splitService.getWeightUnit());
    this.SITE_VOLUME_UNIT = this.$filter('translate')(this.splitService.getVolumeUnit());
    this.container = document.getElementById('visit-plan-routes-timeline');
    this.groupsDataSet = new DataSet();
    this.itemsDataSet = new DataSet();
    // this.jobsMap = _.keyBy(this.jobs, (j) => {
    //   return j.id
    // })

    const options = {
      // option groupOrder can be a property name or a sort function
      // the sort function must compare two groups and return a value
      //     > 0 when a > b
      //     < 0 when a < b
      //       0 when a == b
      groupOrder: (a, b) => {
        return a.order - b.order;
      },
      groupOrderSwap: (groupDragged, groupToSwap) => {
        const value = groupDragged.order;
        groupDragged.order = groupToSwap.order;
        groupToSwap.order = value;
      },
      groupTemplate: (group) => {

        if (!group) {
          return null;
        }

        const container = document.createElement('div');
        container.classList.add("table-container");

        // var columns = [
        //   {key: 'resource', values: [group.resourceName, group.status, group.relatedRoutes]},
        //   {key: 'agent', values: [group.agentName, group.agentSkills]},
        //   {key: 'vehicle', values: [group.vehicle]},
        //   {key: 'value', values: [group.value]},
        //   {key: 'cost', values: [group.cost]},
        //   {key: 'distance', values: [group.distance]},
        //   {key: 'stops', values: [group.stops]},
        //   {
        //     key: 'capacity', values: [
        //       {v: group.weight, max: group.maxWeight, icon: $weightIcon, unit: SITE_WEIGHT_UNIT},
        //       {v: group.volume, max: group.maxVolume, icon: $volumeIcon, unit: SITE_VOLUME_UNIT},
        //       {v: group.packagesCount, max: group.maxPackagesCount, icon: $packageIcon},
        //       {v: group.spots, max: group.maxSpots, icon: $spotsIcon}
        //     ]
        //   },
        //   {key: 'alerts', values: [group.alerts]},
        //   {key: 'timeWindow', values: [group.timeWindow, group.duration]},
        //   {key: 'startEnd', values: [group.startDepot, group.endDepot]}
        // ];

        let columns = [
          {key: 'resource', values: [group.resourceName, group.status, group.relatedRoutes]},
          // {key: 'income', values: [group.totalIncome]},
          // {
          //   key: 'capacity', values: [
          //     {v: group.weight, max: group.maxWeight, icon: this.$weightIcon, unit: this.SITE_WEIGHT_UNIT},
          //     {v: group.volume, max: group.maxVolume, icon: this.$volumeIcon, unit: this.SITE_VOLUME_UNIT},
          //     {v: group.packagesCount, max: group.maxPackagesCount, icon: this.$packageIcon},
          //     {v: group.spots, max: group.maxSpots, icon: this.$spotsIcon}
          //   ]
          // }
        ];

        if (!this.displayPrice) {
          columns = _.filter(columns, (c) => {
            return c.key !== 'value' && c.key !== 'cost';
          })
        }

        const actionsContainer = document.createElement('div');
        actionsContainer.classList.add("table-item", 'action-item-container', 'padding-0');

        // const actionsButton = this.$menuIcon.cloneNode(true);
        // actionsButton.classList.add("margin-0", "route-actions");

        const routeColorDiv = document.createElement('div');
        routeColorDiv.classList.add("route-color");
        routeColorDiv.style.setProperty('background-color', group.color);

        const eyeButton = this._createEyeButton(group.id, !_.includes(this.hiddenRouteIds, group.id));

        // const testButton = this._createEyeButton('change-resource-btn', !_.includes(this.hiddenRouteIds, group.id), (event) => {
        //   if (group.id) {
        //     this.onChangeRouteResource({routeId: group.id, event: event})
        //   }
        // });

        // const infoButton = this._createInfoButton(group.id, (routeId) => {
        //   if (group.id) {
        //     this.onRouteInfoClick({id: group.id});
        //   }
        // });

        // const blockButton = this._createBlockButton(group.id, group.locked, () => {
        //   if (group.id) {
        //     this.onLockRouteChange({id: group.id, locked: !group.locked});
        //   }
        // });

        var iconsDiv = document.createElement('div');
        iconsDiv.classList.add("group-action-div");

        if (group.status === 'DISPATCHED') {
          const linkButton = this._createLinkButton(group.id, group.dispatchedRouteId);
          iconsDiv.appendChild(linkButton);
        }

        iconsDiv.appendChild(eyeButton);

        // iconsDiv.appendChild(testButton);
        // iconsDiv.appendChild(infoButton);
        // iconsDiv.appendChild(blockButton);


        // actionsContainer.appendChild(actionsButton);
        actionsContainer.appendChild(routeColorDiv);
        actionsContainer.appendChild(iconsDiv);

        // const blockDiv = document.createElement('div');
        // const blockButton = this._createBlockButton(group.id, group.locked, () => {
        //   if (group.id) {
        //     this.onLockRouteChange({id: group.id, locked: !group.locked});
        //   }
        // });
        //
        // blockDiv.appendChild(blockButton);
        // actionsContainer.appendChild(blockDiv);

        container.insertAdjacentElement('beforeend', actionsContainer);

        // actionsButton.addEventListener("click", (ev) => {
        //   if (this.canEdit && !group.locked) {
        //     const actions = ['Reoptimize', 'Delete'];
        //     const route = _.find(this.allRoutes, r => {
        //       return r.id === group.id;
        //     })
        //     if (route.resource.sequence && !this.draft.settings.ignoreSequence) {
        //       actions.unshift('Reoptimize & ignore sequence');
        //     }
        //     if (route.status !== 'DISPATCHED') {
        //       actions.unshift('Dispatch');
        //     }
        //     this.commonsService.openActionPanel(actions, ev)
        //       .then((reason) => {
        //         if (group.id) {
        //           if (_.isEqual(reason, 'Dispatch')) {
        //             this.onDispatchRoute({routeId: group.id});
        //           }
        //           if (_.isEqual(reason, 'Reoptimize & ignore sequence')) {
        //             this.onRecalcRoute({routeId: group.id, ignoreSequence: true});
        //           }
        //           if (_.isEqual(reason, 'Reoptimize')) {
        //             this.onRecalcRoute({routeId: group.id});
        //           }
        //           if (_.isEqual(reason, 'Delete')) {
        //             this.onDeleteRoute({routeId: group.id});
        //           }
        //         }
        //       })
        //       .catch((reason) => {
        //         this.$log.info('Action Panel Closed', reason);
        //       });
        //   }
        // }, {passive: true});

        _.forEach(columns, (c) => {
          const element = document.createElement('div');
          const elementColumns = [];

          element.classList.add("table-item", "br-caption-2", c.key);
          if (c.key === 'capacity') {
            element.classList.add("flex-row");
            _.times(2, (num) => {
              const column = document.createElement('div');
              if (num === 0) {
                column.style.width = '130px';
                column.classList.add('text-ellipsis');
              }
              column.classList.add('flex-column');
              elementColumns.push(column);
            })
          }
          _.forEach(c.values, (value, index) => {
            let valueElement;
            if (c.key === 'capacity') {
              valueElement = document.createElement('div');
              const span = document.createElement('span');
              span.classList.add("br-body-1", "font-weight-400", c.key);

              valueElement.classList.add("item-value", c.key);

              span.textContent = (value.v > 1000 ? (value.v / 1000).toFixed(1).replace(/\.0$/, '') + 'K' : value.v) + '/' +
                (value.max > 1000 ? (value.max / 1000).toFixed(1).replace(/\.0$/, '') + 'K' : value.max) + ' ' + (value.unit || '');

              const iconRef = angular.copy(value.icon);

              const loadPercentage = value.v / value.max;
              if (Number.isNaN(loadPercentage)) {
                iconRef.classList.add("margin-left-0", "unlimited");
              } else if (loadPercentage < 0.7) {
                iconRef.classList.add("margin-left-0", "available");
              } else if (loadPercentage > 1) {
                iconRef.classList.add("margin-left-0", "overloaded");
              } else {
                iconRef.classList.add("margin-left-0", "warning");
              }

              valueElement.appendChild(iconRef);
              valueElement.appendChild(span);
              if (index < 2) {
                elementColumns[0].appendChild(valueElement);
              } else {
                elementColumns[1].appendChild(valueElement);
              }
            } else if (c.key === 'resource') {
              if (index === 0) {

                valueElement = document.createElement('span');
                valueElement.setAttribute("id", "change-resource-btn");
                valueElement.classList.add("item-value", "br-body-1", "font-weight-400", "text-ellipsis", c.key);
                valueElement.textContent = value;

                // Change Resource Button Event Listener
                // valueElement.addEventListener("click", (event) => {
                //   this._onClicked().then(() => {
                //     this.onChangeRouteResource({routeId: group.id, event: event})
                //   });
                // }, {passive: true});
              }
              if (index === 1) {
                valueElement = document.createElement('span');
                valueElement.classList.add("item-value", "br-body-1", "font-weight-400", "route-status", group.status);
                valueElement.textContent = value ? this.$filter('translate')('STATUS_TAG.' + value) : '';
              }
              if (index === 2) {

                let relationsGroupSection = undefined

                if (_.get(value, 'length')) {
                  const linkedRoutesBtn = this.$linkIcon.cloneNode(true);
                  linkedRoutesBtn.classList.add("route-relation-button");

                  linkedRoutesBtn.appendChild(this._getRelatedRoutesIndicationDiv(value));

                  relationsGroupSection = document.createElement('div');
                  relationsGroupSection.classList.add("route-relation-button-container");

                  relationsGroupSection.appendChild(linkedRoutesBtn);

                  if (group && group.id) {
                    linkedRoutesBtn.dataset.bzAction = 'combine-related-routes';
                    linkedRoutesBtn.dataset.bzId = String(group.id);
                    linkedRoutesBtn.dataset.bzRelatedIds = (group.relatedRoutes || []).join(',');
                  }
                }

                if (relationsGroupSection) {
                  valueElement = relationsGroupSection;
                }
              }
            } else if (c.key === 'income') {
              if (index === 0) {
                const incomeClass = (!!group.minimumIncome && (group.totalIncome < group.minimumIncome)) ? 'low' :
                  ((!!group.maximumIncome && (group.totalIncome > group.maximumIncome)) ? 'high' : 'mid');

                valueElement = document.createElement('span');
                valueElement.classList.add("item-value", "br-body-1", "font-weight-400", c.key, incomeClass);
                valueElement.textContent = this.$filter('bringozPrice')(group.totalIncome);
              }
            } else if (c.key === 'alerts') {
              valueElement = document.createElement('div');
              valueElement.classList.add("item-value", "br-body-1", c.key);

              const warningCount = document.createElement('span');
              warningCount.textContent = value.length || '---';

              if (value.length) {
                warningCount.classList.add("warn");
              }

              const tooltip = document.createElement('div');
              tooltip.classList.add("table-tooltip");
              const tooltipContainer = document.createElement('div');
              tooltipContainer.classList.add("tooltip-container");

              const warningList = this._getWarningDetails(value);
              _.forEach(warningList, (w) => {
                const infoRow = document.createElement('div');
                infoRow.classList.add("info-row");

                const icon = this.$errorIcon.cloneNode(true);
                icon.classList.add("warn");

                const warningDetails = document.createElement('span');
                warningDetails.textContent = w;

                infoRow.appendChild(icon);
                infoRow.appendChild(warningDetails);
                tooltipContainer.appendChild(infoRow);
              });

              tooltip.appendChild(tooltipContainer);

              valueElement.appendChild(warningCount);

              if (value.length) {
                valueElement.appendChild(tooltip);
              }
            } else if (c.key === 'agent') {
              if (index === 0) {
                valueElement = document.createElement('span');
                valueElement.classList.add("item-value", "br-body-1", "font-weight-400", c.key);
                valueElement.textContent = value;
              }
              if (index === 1) {
                valueElement = document.createElement('div');
                const skillsContainer = document.createElement('div');
                skillsContainer.classList.add('skill-tags-container');
                _.forEach(value, function (s, i) {

                  const skill = document.createElement('div');
                  skill.classList.add('skill-tag', 'skill-tag-margin');

                  const skillText = document.createElement('span')
                  skillText.classList.add("item-value", "br-body-1", "font-weight-400", c.key);
                  skillText.textContent = s;
                  skill.appendChild(skillText);
                  skillsContainer.appendChild(skill);
                })
                valueElement.appendChild(skillsContainer);
              }
            } else {
              valueElement = document.createElement('span');
              valueElement.classList.add("item-value", "br-body-1", "font-weight-400", c.key);
              valueElement.textContent = value;
            }
            if (elementColumns.length) {
              _.forEach(elementColumns, function (c) {
                element.appendChild(c);
              })
            } else if (valueElement) {
              element.insertAdjacentElement('beforeend', valueElement);
            }
          });
          container.insertAdjacentElement('beforeend', element);
        });

        return container;
      },
      onMoving: (item, callback) => {
        if (item.stopId || item.stopIds) {
          callback(item); // updating the item
        } else {
          callback(null); // cancel updating the item
        }
      },
      onMove: (item, callback) => {
        const fromRouteId = item.routeId;
        const toRouteId = item.group;
        const isBetweenRoutes = fromRouteId !== toRouteId;
        const routeToRef = isBetweenRoutes ? _.find(this.routes, ['id', item.group]) : undefined

        callback(item);
        const canMove = this._canItemMove(item);

        if (!!routeToRef?.locked) {
          this.planningAlertsService.routeIsLocked();
          callback(null);
          return;
        }

        if (!canMove) {
          callback(null);
          return;
        }

        const groupsMap = this.timeline.components[3].groups;
        const isGroupActivity = _.isEqual(item.activityType, 'GROUP');

        if (isGroupActivity && !!isBetweenRoutes) {
          this.planningDialogService.selectActivity(item.ref.stopActivities)
            .then((selectedActivities) => {

              let itemJobs = [];

              if (!!this.jobs?.length) {
                itemJobs = _.map(selectedActivities, (activity) => {
                  return this.jobsMap[activity.jobId];
                })
              }

              let isValidateRouteVehicle = false;
              for (let job of itemJobs) {
                if (this.isValidateRouteVehicles && !!routeToRef.resource?.vehicleClass &&
                  job.allowedVehicleTypes?.length && !job.allowedVehicleTypes.includes(routeToRef.resource.vehicleClass)) {
                  isValidateRouteVehicle = true;
                  break;
                }
              }

              if (isValidateRouteVehicle) {
                const confirmDialogDescription = itemJobs.length > 1 ? "Services vehicle types do not match route resource vehicle type. Are you sure you want to proceed?" :
                  "Service vehicle types do not match route resource vehicle type. Are you sure you want to proceed?"
                this.confirmDialogService.confirm("Confirm",
                  confirmDialogDescription)
                  .then(() => {
                    if (item.ref.stopActivities.length === selectedActivities.length) {
                      this.onMoveItem(
                        {
                          jobIds: item.jobIds,
                          fromRouteId: fromRouteId,
                          toRouteId: toRouteId,
                          fromOrderedIds: _getStopsOrderIds(groupsMap[fromRouteId].orderedItems.byStart),
                          toOrderedIds: isBetweenRoutes ? _getStopsOrderIds(groupsMap[toRouteId].orderedItems.byStart) : undefined
                        }
                      );
                    } else {
                      const originalRoute = _.find(this.routes, (r) => {
                        return r.id === fromRouteId;
                      })
                      const fromOrderIds = _.chain(originalRoute.activities)
                        .filter((a) => {
                          return _.isEqual(a.type, 'STOP') || _.isEqual(a.type, 'GROUP')
                        })
                        .map((filteredActivity) => {
                          const stopIds = filteredActivity.stopId ? [filteredActivity.stopId] : angular.copy(filteredActivity.stopIds);

                          _.forEach(_.map(selectedActivities, 'stopId'), (stopIdToRemove) => {
                            const removeIndex = _.findIndex(stopIds, (id) => {
                              return id === stopIdToRemove;
                            })
                            if (removeIndex > -1) {
                              stopIds.splice(removeIndex, 1);
                            }
                          });
                          return stopIds;
                        })
                        .flatten()
                        .value();

                      const toOrderedIds = _.chain(_getStopsOrderIds(groupsMap[toRouteId].orderedItems.byStart))
                        .map((stopId) => {
                          return _.includes(item.stopIds, stopId) ? _.map(selectedActivities, 'stopId') : stopId;
                        })
                        .flatten()
                        .uniq()
                        .value();

                      this.onMoveItem(
                        {
                          jobIds: _.map(selectedActivities, 'jobId'),
                          fromRouteId: fromRouteId,
                          toRouteId: toRouteId,
                          fromOrderedIds: fromOrderIds,
                          toOrderedIds: toOrderedIds
                        }
                      );
                    }
                  })
                  .catch(() => {
                    callback(null);
                    return;
                  });
              } else {
                if (item.ref.stopActivities.length === selectedActivities.length) {
                  this.onMoveItem(
                    {
                      jobIds: item.jobIds,
                      fromRouteId: fromRouteId,
                      toRouteId: toRouteId,
                      fromOrderedIds: _getStopsOrderIds(groupsMap[fromRouteId].orderedItems.byStart),
                      toOrderedIds: isBetweenRoutes ? _getStopsOrderIds(groupsMap[toRouteId].orderedItems.byStart) : undefined
                    }
                  );
                } else {
                  const originalRoute = _.find(this.routes, (r) => {
                    return r.id === fromRouteId;
                  })
                  const fromOrderIds = _.chain(originalRoute.activities)
                    .filter((a) => {
                      return _.isEqual(a.type, 'STOP') || _.isEqual(a.type, 'GROUP')
                    })
                    .map((filteredActivity) => {
                      const stopIds = filteredActivity.stopId ? [filteredActivity.stopId] : angular.copy(filteredActivity.stopIds);

                      _.forEach(_.map(selectedActivities, 'stopId'), (stopIdToRemove) => {
                        const removeIndex = _.findIndex(stopIds, (id) => {
                          return id === stopIdToRemove;
                        })
                        if (removeIndex > -1) {
                          stopIds.splice(removeIndex, 1);
                        }
                      });
                      return stopIds;
                    })
                    .flatten()
                    .value();

                  const toOrderedIds = _.chain(_getStopsOrderIds(groupsMap[toRouteId].orderedItems.byStart))
                    .map((stopId) => {
                      return _.includes(item.stopIds, stopId) ? _.map(selectedActivities, 'stopId') : stopId;
                    })
                    .flatten()
                    .uniq()
                    .value();

                  this.onMoveItem(
                    {
                      jobIds: _.map(selectedActivities, 'jobId'),
                      fromRouteId: fromRouteId,
                      toRouteId: toRouteId,
                      fromOrderedIds: fromOrderIds,
                      toOrderedIds: toOrderedIds
                    }
                  );
                }
              }


            })
            .catch(() => {
              callback(null);
            })
            .finally(() => {
              this.movingItem = undefined;
            })
        } else {
          this.onMoveItem(
            {
              jobIds: item.jobIds,
              fromRouteId: fromRouteId,
              toRouteId: toRouteId,
              fromOrderedIds: _getStopsOrderIds(groupsMap[fromRouteId].orderedItems.byStart),
              toOrderedIds: isBetweenRoutes ? _getStopsOrderIds(groupsMap[toRouteId].orderedItems.byStart) : undefined
            }
          );
          this.movingItem = undefined;
        }

        function _getStopsOrderIds(items) {
          return _.chain(items)
            .filter((item) => {
              return _.isEqual(item.data.activityType, 'STOP') || _.isEqual(item.data.activityType, 'GROUP');
            })
            .map((filteredItem) => {
              return filteredItem.data.stopId || filteredItem.data.stopIds;
            })
            .flatten()
            .value();
        }
      },
      snap: (date, scale, step) => {
        const minute = 60 * 1000;
        return Math.round(date / minute) * minute;
      },
      onAdd: (data, callback) => {

        if (!data.items || !data.items.length) {
          callback(null);
          return;
        }

        const canAdd = this._canLeftoversAddToRoute(data.items, data.group);

        if (!canAdd) {
          callback(null);
          return;
        }

        const route = _.find(this.routes, (r) => {
          return r.id === data.group;
        });

        if (!!route.locked) {
          this.planningAlertsService.routeIsLocked();
          callback(null);
          return;
        }

        let index = 0;
        let order = [];
        let stopActivities = _.filter(route.activities, (a) => {
          return _.isEqual(a.type, 'STOP') || _.isEqual(a.type, 'GROUP')
        })

        _.forEach(stopActivities, (a, i) => {
          if (a.eta < data.start.valueOf()) {
            index = i + 1;
          }
          if (_.isEqual(a.type, 'STOP')) {
            order.push(a.stopId);
          }
          if (_.isEqual(a.type, 'GROUP')) {
            order = order.concat(a.stopIds);
          }
        });

        let stopIds = [];
        let jobIds = [];
        _.forEach(data.items, (i) => {
          stopIds = stopIds.concat(i.stopIds);
          jobIds = jobIds.concat(i.jobIds)
        });

        _.forEach(stopIds, (id, i) => {
          order.splice(index + i, 0, id);
        });
        this.onAddStopsToRoute({routeId: data.group, jobIds: jobIds, order: order});
        callback(null);
      },
      orientation: 'top',
      format: {
        minorLabels: {
          minute: this.timeFormat,
          hour: this.timeFormat,
          weekday: this.longDateFormat,
          day: this.shortDateFormat
        }
      },
      // editable: true,
      // selectable: true,
      // multiselect: false,
      editable: {
        add: this.canEdit,                       // add new items by double tapping
        updateTime: this.canEdit,        // drag items horizontally
        updateGroup: this.canEdit,      // drag items from one group to another
        remove: false,                 // delete an item by tapping the delete button top right
        overrideItems: false          // allow these options to override item.editable
      },
      xss: {
        disabled: true,
        // filterOptions: {
        //   whiteList: { p: ['class', 'data-from-template'], div: 'class' },
        // },
      },
      // tooltipOnItemUpdateTime: {
      //   template: function(item) {
      //     // Option to add tooltip when dragging item (useful)
      //     return 'html template for tooltip with <b>item.start</b>: ' + item.start;
      //   }
      // },
      groupEditable: true,
      verticalScroll: true,
      zoomKey: 'ctrlKey',
      width: '100%',
      height: '100%',
      // margin: {
      //     item: 5
      // },
      margin: {
        item: {
          horizontal: -1,
          vertical: 20
        },
        axis: 10
      },
      stack: !this.isGroupedRoutes,
      showTooltips: true,
      tooltip: {
        followMouse: true
      },
      start: this.moment(this.from).subtract(1, 'hour'),
      end: this.moment(this.to).add(1, 'hour'),
      // min: moment(ctrl.from).subtract(1, 'hour'),
      // max: moment(ctrl.to).add(1, 'hour'),
      zoomMin: 1080000 // Zoom In Max 5 Mins
      // zoomMax: 18800000 // Zoom Out Max 1 Hour,
    };
    this.timeline = new this.vis.Timeline(this.container, this.itemsDataSet, this.groupsDataSet, options);

    // Single delegated click handler — replaces per-cell addEventListener calls
    // inside groupTemplate so listener count stays O(1) regardless of vis redraws.
    this.container.addEventListener('click', this._onContainerClick);

    let customDate = this.moment(this.to).toDate();
    this.timeline.addCustomTime(customDate);
    this.timeline.customTimes[0].hammer.off("panstart panmove panend");

    // Check permissions to update roues
    if (_.isUndefined(this.canEdit)) {
      this.canEdit = false;
    }

    // Set Table Header Element
    const topElementRef = this.timeline.body.dom.top;
    topElementRef.style = 'left: 0px';
    this.tableHeaderDivRef = document.createElement("div");
    this.tableHeaderDivRef.classList.add("table-header-container");
    topElementRef.before(this.tableHeaderDivRef);

    this.jobsMap = _.keyBy(this.jobs, (j) => {
      return j.id
    })


    if (this.routes?.length) {
      this._addRoutesToTimeline(this.routes);
      // this._addActivitiesToTimeline(this.routes);
      if (this.jobs?.length) {
        this._addActivitiesToTimeline(this.routes);
      }
      if (this.resources?.length) {
        this.itemsDataSet.add(this._getResourceItemsData(this.resources));
        // this.itemsDataSet.add(this._getScheduleBreaksItemsData(this.resources));
      }
      // this.fitTimeline();
      this.isFirstFit = false;
    }


    this._initTimelineEventListeners();
    this.fitTimeline();
  };

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.draftAnalysis && !changes.draftAnalysis.isFirstChange()) {
      // this.groupsDataSet.clear();
      // this.itemsDataSet.clear();
      //
      // this._addRoutesToTimeline(this.routes);
      // this._addActivitiesToTimeline(this.routes);
    }

    if (changes.jobs && !changes.jobs.isFirstChange()) {

      this.jobsMap = _.keyBy(this.jobs, (j) => {
        return j.id
      })

      this.itemsDataSet?.clear();

      if (this.jobs?.length) {
        this._addActivitiesToTimeline(this.routes);
      }

      if (this.isFirstFit) {
        this.fitTimeline();
        this.isFirstFit = false;
      }
    }

    // if (changes.resources) {
    //   this.$timeout(() => {
    //     if (this.itemsDataSet) {
    //       this.itemsDataSet.remove(_.map(this.resources, 'id'));
    //       if (this.resources?.length) {
    //         this.itemsDataSet.add(this._getResourceItemsData(this.resources));
    //       }
    //     }
    //   }, 500);
    // }

    if (changes.routes && !changes.routes.isFirstChange()) {
      const currentRoutes = changes.routes.currentValue || [];
      const previousRoutes = changes.routes.previousValue || [];

      // PlanningDraftService.getRoutesChanges(currentRoutes, previousRoutes)

      const routesToAdd: any[] = _.differenceBy(currentRoutes, previousRoutes, 'id');
      const routesToRemove: any[] = _.differenceBy(previousRoutes, currentRoutes, 'id');

      const currentUpdatedRoutes = _.differenceBy(currentRoutes, routesToAdd, 'id');
      const previousUpdatedRoutes = _.differenceBy(previousRoutes, routesToRemove, 'id');

      const currentRoutesToUpdate = _.filter(currentUpdatedRoutes, (currentUpdatedRoute: any) => {
        let previousUpdatedRoute: any = _.find(previousUpdatedRoutes, ['id', currentUpdatedRoute.id]);

        // Check if route was changed
        return (_.get(previousUpdatedRoute, 'activities.length') !== _.get(currentUpdatedRoute, 'activities.length')) ||
          (previousUpdatedRoute.updatedAt < currentUpdatedRoute.updatedAt);
      });

      const previousRoutesToUpdate = _.filter(previousUpdatedRoutes, (previousUpdatedRoute: any) => {
        const currentUpdatedRoute: any = _.find(currentUpdatedRoutes, ['id', previousUpdatedRoute.id]);
        // Check if route was changed
        return (_.get(currentUpdatedRoute, 'activities.length') !== _.get(previousUpdatedRoute, 'activities.length')) ||
          previousUpdatedRoute.updatedAt < currentUpdatedRoute.updatedAt;
      });

      // Remove groups and items
      const activitiesToRemove = _.flatMap(_.concat(routesToRemove, previousRoutesToUpdate), 'activities');
      const activityItemIdsToRemove = _.map(activitiesToRemove, 'id');
      let routesToRemoveBackgroundItems = [];
      let routesToRemoveTripItems = [];
      routesToRemove.forEach(r => {
        r.activities.forEach(a => {
          routesToRemoveBackgroundItems.push(r.id + a.id);

          if (a.tripNumber) {
            routesToRemoveTripItems = _.uniq(routesToRemoveTripItems.concat(r.id + a.tripNumber));
          }
        })
      })
      let previousRoutesToUpdateBackgroundItems = [];
      previousRoutesToUpdate.forEach(r => {
        r.activities.forEach(a => {
          previousRoutesToUpdateBackgroundItems.push(r.id + a.id);
        })
      })
      const backgroundItemIdsToRemove = _.concat(routesToRemoveBackgroundItems, routesToRemoveTripItems, previousRoutesToUpdateBackgroundItems);
      const routeIdsToRemove = _.map(routesToRemove, 'id');


      if (routeIdsToRemove.length) {
        this.groupsDataSet.remove(routeIdsToRemove);
      }

      if (_.concat(activityItemIdsToRemove, backgroundItemIdsToRemove).length) {
        this.itemsDataSet.remove(_.concat(activityItemIdsToRemove, backgroundItemIdsToRemove));
      }

      // Create groups and items
      // var routesToAddAndUpdate = _.concat(routesToAdd, routesToUpdate);
      this.$timeout(() => {
        this._addRoutesToTimeline(routesToAdd);
        this._addActivitiesToTimeline(_.concat(routesToAdd, currentRoutesToUpdate));

        if (this.itemsDataSet) {
          this.itemsDataSet.remove(_.map(this.resources, 'id'));
          if (this.resources?.length) {
            this.itemsDataSet.add(this._getResourceItemsData(this.resources));
          }
        }

        // if (this.resources?.length && routesToAdd) {
        //   this.itemsDataSet.add(this._getResourceItemsData(this.resources));
        // }
      }, 0);
      // var groupsToAdd = _mapRoutesToGroups(routesToAdd, ctrl.draftAnalysis);
      // var activityItemsToAdd = _mapRoutesToActivityItems(_.concat(routesToAdd, currentRoutesToUpdate), ctrl.draftAnalysis);
      // var backgroundItemsToAdd = _mapRoutesToBackgroundItems(_.concat(routesToAdd, currentRoutesToUpdate));
      //
      // groupsDataSet.add(_.sortBy(groupsToAdd, ['resourceName', 'eta']));
      // itemsDataSet.add(_.concat(activityItemsToAdd, backgroundItemsToAdd));

      // Update groups and items

      if (currentRoutesToUpdate.length) {
        const groupsToUpdate = this._mapRoutesToGroups(currentRoutesToUpdate, this.draftAnalysis);
        this.groupsDataSet.update(groupsToUpdate);
      }

      if (this.inspectedStopIds?.length) {
        this._setInspectedItemsByIds(this.inspectedStopIds);
      }

      if (this.isFirstFit) {
        this.fitTimeline();
        this.isFirstFit = false;
      }
    }

    // if (changes.selectedItemId && !changes.selectedItemId.isFirstChange()) {
    //   const currentSelectedId = changes.selectedItemId.currentValue;
    //   const previousSelectedId = changes.selectedItemId.previousValue;
    //
    //   const selectedTask = this._getTimelineActivityById(this.selectedItemId);
    //   if (selectedTask) {
    //     this.timeline.setSelection(selectedTask.id);
    //   }
    //   this._updateTimelineSelectedTassStyle(currentSelectedId, previousSelectedId);
    // }

    if (changes.selectedJobIds) {
      const previousSelectedActivities = angular.copy(this.selectedActivities || []);
      this.selectedActivities = this._getTimelineActivitiesByJobIds(this.selectedJobIds);
      if (!!this.selectedActivities.length) {
        this.timeline.setSelection(this.selectedActivities);
      }

      this._updateTimelineSelectedActivitesStyle(this.selectedActivities.map(a => a.id), previousSelectedActivities.map(a => a.id));
    }

    if (changes.from && !changes.from.isFirstChange() ||
      changes.to && !changes.to.isFirstChange()) {
      this.options.min = this.moment(this.from).subtract(1, 'hour');
      this.options.max = this.moment(this.to).add(1, 'hour');
      this.timeline.setOptions(this.options);
    }

    if (changes.isGroupedRoutes && !changes.isGroupedRoutes.isFirstChange()) {
      _.get(this.options, 'stack', undefined)
      this.options.stack = !this.isGroupedRoutes;
      this.timeline.setOptions(this.options);
    }

    if (changes.hiddenRouteIds && !changes.hiddenRouteIds.isFirstChange()) {
      const eyeButtons = document.getElementsByClassName("eye-button");
      _.forEach(eyeButtons, (b: any) => {
        const isEnabled = !_.includes(this.hiddenRouteIds, b.id);
        b.src = isEnabled ? this.iconsUrl.eyeOff : this.iconsUrl.eyeOn;
        b.enabled = isEnabled;
        // b.style.opacity = isEnabled ? '1' : '0.5';
      });
    }

    if (changes.inspectedStopIds && !changes.inspectedStopIds.isFirstChange()) {
      this._setInspectedItemsByIds(this.inspectedStopIds);
    }

    if (changes.doFit && !changes.doFit.isFirstChange()) {
      if (this.doFit) {
        this.fitTimeline();
      }
    }

  }


  // ******************************
  //        Public methods
  // ******************************

  onChangeShowTooltips(showTooltips) {
    this.options.showTooltips = showTooltips;
    this.timeline.setOptions(this.options);
  }

  public _addRoutesToTimeline(routes) {

    // Make sure the routes doesnt exist in timeline before adding them.
    const currentRouteIdsInTimeline = this.groupsDataSet.getIds();
    routes = _.filter(routes, (r) => {
      return !_.includes(currentRouteIdsInTimeline, r.id);
    })

    const groups = this._mapRoutesToGroups(routes, this.draftAnalysis);
    this.groupsDataSet.add(_.sortBy(groups, ['resourceName', 'eta']));
  }

  public _addActivitiesToTimeline(routes) {
    const activityItems = this._mapRoutesToActivityItems(routes, this.draftAnalysis);
    const routeIds = _.map(routes, 'id');
    let reTripItems = [];
    if (this.draft?.settings?.planRetrips) {
      reTripItems = this._mapRoutesToReTripsItems(routes);
    }

    // // Remove RoutesRetripItems
    // const itemsToRemove = [];
    // this.itemsDataSet.forEach((item) => {
    //   if (item.isRetrip && _.includes(routeIds, item.routeId)) {
    //     retripItemIdsToRemove.push(item.id);
    //   }
    // })

    // if (retripItemIdsToRemove.length) {
    //   this.itemsDataSet.remove(retripItemIdsToRemove);
    // }

    const backgroundItems: any = this._mapRoutesToBackgroundItems(routes);
    const itemIdsToRemoveBeforeAdd = _.map(_.concat(activityItems, reTripItems, backgroundItems), 'id');

    const itemsToRemove = [];
    this.itemsDataSet.forEach((item) => {
      if (_.includes(itemIdsToRemoveBeforeAdd, item.id) || (item.isRetrip && _.includes(routeIds, item.routeId))) {
        itemsToRemove.push(item.id);
      }
    })

    if (itemsToRemove.length) {
      this.itemsDataSet.remove(itemsToRemove);
    }

    this.$timeout(0).then(() => {
      this.itemsDataSet.add(_.concat(activityItems, reTripItems, backgroundItems));
      this.fitTimeline();
    });
  }

  public _mapRoutesToGroups(routes, analysis) {
    const routeDependencies = _.get(analysis, 'routeDependencies', {}),   // A MAP BY ID// A MAP BY ID
      routeWarnings = _.get(analysis, 'routeWarnings', {});
    return _.map(routes, (route) => {
      const routeWarningsRef = routeWarnings[route.id];
      const color = !!this.agentColorMap ? this.agentColorMap[route.resource.agentId] : this._getRouteColor(route.id);
      const relatedRoutes = routeDependencies[route.id];
      return this._getGroupData(route, color, relatedRoutes, routeWarningsRef);
    });
  }

  public _mapRoutesToActivityItems(routes, analysis) {
    const routeDependencies = _.get(analysis, 'routeDependencies', {}),   // A MAP BY ID
      stopDependencies = _.get(analysis, 'stopDependencies', {}),     // A MAP BY ID
      stopWarnings = _.get(analysis, 'stopWarnings', {}); // A MAP BY ID
    return _.flatMap(routes, (route) => {
      const color = !!this.agentColorMap ? this.agentColorMap[route.resource.agentId] : this._getRouteColor(route.id);
      return this._getItemsData(route, route.activities, color, routeDependencies, stopDependencies, stopWarnings);
    });
  }

  public _mapRoutesToReTripsItems(routes) {
    return _.flatMap(routes, (route) => {
      const color = !!this.agentColorMap ? this.agentColorMap[route.resource.agentId] : this._getRouteColor(route.id);
      return this._getReTripItemsData(route, color);
    });
  }

  public _mapRoutesToBackgroundItems(routes) {
    // return _.flatMap(routes, (route) => {
    //   const color = this._getRouteColor(route.id);
    //   return this._mapRouteToBackgroundItem(route, color);
    // });
    let backgroundItems = [];
    routes.forEach((route) => {
      const color = !!this.agentColorMap ? this.agentColorMap[route.resource.agentId] : this._getRouteColor(route.id);
      const items = this._mapRouteToBackgroundItem(route, color)
      backgroundItems.push(...items);
    })
    return backgroundItems;
  }

  public _mapRouteToBackgroundItem(route, color) {
    let backgroundItems = [];

    let currentPackagesOnCurrentLocation = [];

    route.activities.forEach((activity, index) => {
      if (!route.activities[index + 1]) {
        return;
      }

      if (activity.stopType === 'Pickup') {
        currentPackagesOnCurrentLocation.push(...activity.packages);
      }

      if (activity.stopType === 'Dropoff') {
        activity.packages.forEach(activityPackage => {
          const packageIndex = currentPackagesOnCurrentLocation.findIndex(currentPackage => activityPackage.id === currentPackage.id);
          if (packageIndex > -1) {
            currentPackagesOnCurrentLocation.splice(packageIndex, 1)
          }
        })
      }
      const backgroundItem: any = {
        id: route.id + activity.id,
        start: this.moment(activity.eta),
        end: this.moment(route.activities[index + 1].eta),
        group: route.id,
        type: 'background',
        style: 'background-color: ' + color,
        className: `route-background ${!currentPackagesOnCurrentLocation.length ? 'empty' : ''}`
      }

      backgroundItems.push(backgroundItem);
    })
    return backgroundItems;
    // return {
    //   id: route.id,
    //   start: this.moment(route.activities[0].eta),
    //   end: this.moment(route.activities[route.activities.length - 1].eta),
    //   group: route.id,
    //   type: 'background',
    //   style: 'background-color: ' + color
    // }
  }

  public onToggleSeeAll() {
    const isCurrentlyHidden = this.hiddenRouteIds.length === this.routes.length;
    this.onToggleHiddenRoutes({routeIds: isCurrentlyHidden ? [] : _.map(this.routes, 'id')});
  }

  public onCloseInspectMode() {
    this.onInspectedStopIdsChange({ids: []});
  }

  public fitTimeline() {
    // _onClicked().then(function() {
    //     timeline.fit();
    // });
    // timeline.fit();
    this.$timeout(200).then(() => {
      this.timeline.fit();
      this.onFit();
    });
  }

  onZoom(isZoomIn) {
    isZoomIn ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
  }


  //////////////////////// PRIVATE METHODS ////////////////////////

  private _createEyeButton(id, isEnabled) {
    const eyeButton = this.$eyeIcon.cloneNode(true);
    eyeButton.src = isEnabled ? this.iconsUrl.eyeOff : this.iconsUrl.eyeOn;
    eyeButton.id = id;
    eyeButton.classList.add("cursor-pointer", "eye-button", "gray");
    eyeButton.enabled = isEnabled;
    if (id) {
      eyeButton.dataset.bzAction = 'toggle-route';
      eyeButton.dataset.bzId = String(id);
    }
    return eyeButton;
  }

  private _createLinkButton(id, dispatchedRouteId) {
    const linkButton = this.$goTolinkIcon.cloneNode(true);
    linkButton.src = this.iconsUrl.goToLink;
    linkButton.id = id;
    linkButton.classList.add("cursor-pointer", "go-to-link-button");
    if (dispatchedRouteId) {
      linkButton.dataset.bzAction = 'go-to-dispatched';
      if (id) linkButton.dataset.bzId = String(id);
      linkButton.dataset.bzDispatchedId = String(dispatchedRouteId);
    }
    return linkButton;
  }

  // NOTE: `_createInfoButton` and `_createBlockButton` are currently dead code
  // (their call sites in groupTemplate are commented out). Left untouched to
  // keep this delegation refactor focused; they still attach a per-cell
  // listener if they are ever re-enabled.
  private _createInfoButton(routeId, onClick) {
    const infoButton = this.$infoIcon.cloneNode(true);
    infoButton.classList.add("gray", "cursor-pointer");

    // Button Event Listener
    infoButton.addEventListener("click", () => {
      this._onClicked().then(() => {
        onClick();
      });
    }, {passive: true});

    return infoButton;
  }


  private _getRelatedRoutesIndicationDiv(routeIds) {

    const MAX_COLOR_DIVS = 5;

    routeIds = _.uniq(routeIds);

    const container = document.createElement('div');
    container.classList.add("related-route-div");

    _.forEach(routeIds, (rid, i: number) => {
      if (i + 1 <= MAX_COLOR_DIVS) {
        const color = this._getRouteColor(rid);
        const colorDiv = document.createElement('div');

        colorDiv.classList.add("related-route-color-dot");
        colorDiv.style.backgroundColor = color;
        container.appendChild(colorDiv);
      }
    });

    if (routeIds.length > MAX_COLOR_DIVS) {
      const diff = routeIds.length - MAX_COLOR_DIVS;
      const extraCountSpan = document.createElement('span');
      extraCountSpan.textContent = '+' + diff.toString();
      container.appendChild(extraCountSpan);
    }

    return container;
  }

  private _getWarningDetails(warnings) {
    const mapByType = {};
    const warningList = [];
    _.forEach(warnings, (w) => {
      const warnRef = mapByType[w.type];
      mapByType[w.type] = warnRef ? (warnRef + 1) : 1
    });
    _.forOwn(mapByType, (value, key) => {
      warningList.push(value + ' ' + this.$filter('translate')(key));
      // string += value + ' ' + $filter('translate')(key) + ', '
    });
    return warningList;
  }

  private _getRouteColor(routeId) {
    const route = _.find(this.allRoutes, function (r) {
      return r.id === routeId;
    })
    return this.planningCommonService.getRouteColor(route);
  }

  private _getTranslatedAgentSkills(skills, isFirstLetterOnly) {
    return _.map(skills, (s) => {
      return this._getTranslatedSkill(s, isFirstLetterOnly)
    });
  }

  private _getTranslatedSkill(skill, isFirstLetterOnly) {
    const text = this.$filter('translate')('SKILLS.' + skill);
    return isFirstLetterOnly ? text.charAt(0) : text;
  }

  // ******************************
  //        Private methods
  // ******************************

  private _getGroupData(route, color, relatedRoutes, routeWarnings) {

    const firstActivity: any = _.head(route.activities);
    const lastActivity: any = _.last(route.activities);

    const resourceSource = _.get(route, 'resource.source');
    const resourceName = resourceSource === 'AgentSchedule' ? _.get(route, 'resource.agentName')
      : (_.get(route, 'resource.allocationName') || _.get(route, 'resource.vehicleName', '---'));
    const firstActivityDepotName = _.get(this.depotsMap, firstActivity.depotId + '.name', '---');
    const lastActivityDepotName = _.get(this.depotsMap, lastActivity.depotId + '.name', '---');

    const routeIndex = _.findIndex(this.routes, (r: any) => {
      return r.id === route.id;
    })

    const maxVolume = route.resource?.capacity?.dimensions ?
      (route.resource.capacity.dimensions.height * route.resource.capacity.dimensions.width * route.resource.capacity.dimensions.length) : undefined;

    return {
      id: route.id,
      order: routeIndex,
      locked: route.locked,
      color: color || 'black',
      status: route.status,
      dispatchedRouteId: route.dispatchedRouteId,
      resourceName: resourceName,
      totalIncome: _.get(route, 'totals.totalIncome'),
      minimumIncome: _.get(route, 'resource.routeIncomePreferences.minimumRouteIncome') || _.get(this.draft, 'settings.incomeSettings.minRouteIncome'),
      maximumIncome: _.get(route, 'resource.routeIncomePreferences.maximumRouteIncome') || _.get(this.draft, 'settings.incomeSettings.maxRouteIncome'),
      agentName: _.get(route, 'resource.agentName', '---'), // missing on resource data
      allocationSkills: _.get(route, 'resource.allocationSkills', []),
      agentSkills: this._getTranslatedAgentSkills(_.get(route, 'resource.allocationSkills', []), true), // missing on resource type VEHICLE data - talk to eliav
      vehicle: _.get(route, 'resource.vehicleName', '---'),
      load: this.$filter('bringozWeight')(route.totals.totalLoad, true),
      value: this.$filter('bringozPrice')(route.totals.value),
      cost: this.$filter('bringozPrice')(route.totals.cost),
      distance: this.$filter('bringozDistance')(route.totals.totalDistanceMeter),
      stops: route.totals.totalStopsCount || '---',
      jobs: route.totals.totalJobsCount || '---',
      weightPercentage: route.weightPercentage,
      volumePercentage: route.capacityPercentage,
      weight: _.round(_.get(route.totals, 'totalLoad'), 1),
      maxWeight: _.round(_.get(route, 'resource.capacity.weight'), 1) || this.$infinitySymbol,
      volume: _.round(_.get(route.totals, 'totalVolume'), 1),
      maxVolume: _.round(maxVolume, 1) || this.$infinitySymbol,
      packagesCount: _.get(route.totals, 'totalPackagesCount', '---'),
      maxPackagesCount: _.get(route, 'resource.capacity.numberOfPackages', this.$infinitySymbol),
      spots: _.round(_.get(route.totals, 'totalSpots'), 1) || 0,
      maxSpots: _.round(_.get(route, 'resource.capacity.numberOfSpots'), 1) || this.$infinitySymbol,
      alerts: routeWarnings || [],
      duration: this.$filter('translate')('Duration') + ': ' + this.$filter('bringozTimeConvert')(route.totals.totalTimeSec),
      timeWindow: this.$filter('timeWindow')({
        notBefore: _.get(firstActivity, 'eta'),
        notAfter: _.get(lastActivity, 'eta')
      }),
      eta: _.get(firstActivity, 'eta'),
      className: `group-row br-caption-2 ${route.locked ? 'locked' : ''}`,
      enabled: true, // For Eye icon (show or not in map)
      visible: true, // For filtering the displayed routes in table
      relatedRoutes: relatedRoutes || [],
      startDepot: firstActivityDepotName,
      endDepot: lastActivityDepotName
    };
  }

  private _getItemsData(route, activities, color, routeDependencies, stopDependencies, stopWarnings,) {
    // var stopIndex = 0;

    const relatedRoutes = routeDependencies[route.id];

    const resourceRef = _.find(this.resources, (r) => {
      return r.id === route.resource.id;
    })

    const routeAnalysis = this.analysis?.routes.find((r) => {
      return r.routeId === route.id;
    })

    return _.map(activities, (activity, index) => {
      const defaultServiceTime = 60000;
      const activityServiceTimeInMili = _.get(activity, 'serviceTime', 5) * defaultServiceTime;
      const activityEta = _.get(activity, 'eta');
      const activityEtd = _.get(activity, 'etd', activityEta + activityServiceTimeInMili);

      const activityPurpose = activity.stopType || 'Dropoff';
      const isStop = _.isEqual(activity.type, 'STOP');
      const isGroup = _.isEqual(activity.type, 'GROUP');
      const isPoint = (!isStop && !isGroup);
      const resourceStartTime = _.get(route.resource, 'startTime');
      const resourceStartEndTime = _.get(route.resource, 'endTime');

      const relatedStops = isStop ? stopDependencies[activity.stopId] : (isGroup ? _getStopDependenciesForGroup(stopDependencies) : []),
        warnings = isStop ? stopWarnings[activity.stopId] : (isGroup ? _getStopDependenciesForGroup(stopWarnings) : []);

      const routeVisitScheduleDay = this.visitScheduleDays.find(vsd => vsd.id === route.visitScheduleDayId);

      const activityAnalysis = (routeAnalysis?.activities || []).find((a) => {
        return a.activityId === activity.id;
      })

      let color;

      if (resourceRef?.disabled || (activityAnalysis?.risks?.length || routeAnalysis?.risks?.length)) {
        color = '#D52424';
      } else {
        color = (route.status === 'DISPATCHED' || routeVisitScheduleDay?.status === 'Completed') ? '#A3A3A3' : (this.moment(activityEta).isSameOrAfter(this.moment(resourceStartTime)) && this.moment(activityEtd).isSameOrBefore(this.moment(resourceStartEndTime)) ? '#5094EB' : '#D52424');
      }


      // if (isStop || isGroup) {
      //   stopIndex++;
      // }

      function _getStopDependenciesForGroup(map) {
        const stopActivityIds = _.map(activity.stopActivities, 'stopId');
        const allArrays = _.chain(map)
          .pickBy((value, key) => {
            return _.includes(stopActivityIds, key);
          })
          .toArray()
          .value();
        return _.spread(_.union)(allArrays);
      }

      return {
        ref: activity,
        id: activity.id,
        start: this.moment(activityEta),
        end: this.moment(activityEtd || (activityEta + activityServiceTimeInMili)),
        group: route.id,
        routeId: route.id,
        accountName: activity.accountName,
        activityId: activity.id,
        stopId: activity.stopId,
        routeColor: color,
        stopIds: _.get(activity, 'stopIds', []), // For Groups Only
        jobIds: activity.jobId ? [activity.jobId] : _.get(activity, 'jobIds', []),
        purpose: activityPurpose,
        activityType: activity.type,
        routeStatus: route.status,
        relatedRoutes: relatedRoutes || [],
        relatedStops: relatedStops || [],
        risks: activityAnalysis?.risks,
        warnings: warnings || [],
        point: (!isStop && !isGroup) ? 'point' : 'box',
        title: isPoint ? this._getStartEndTooltip(activity) :
          this._getStopTooltip(activity, route, activityAnalysis, routeAnalysis),
        content: isPoint ?
          this._getStartEndPointsContent(activity, color) :
          this._getStopContent(activity, relatedStops, warnings, color, this.draft?.settings?.planRetrips),
        style: isPoint ?
          'background-color: #7E7E7E !important; color: white;' :
          `background-color: white; border-color: ${color}; color: ${color};`,
        // style: 'background-color: ' + `${color}30` + '; color: white',
        className: isPoint ? 'point' : (isGroup ? 'group' : 'stop'),
        editable: {
          add: false,                                                                // add new items by double tapping
          updateTime: !route.locked && !this.visitPlan.hasNotSyncedChanges && routeVisitScheduleDay.status !== 'Completed',        // drag items horizontally
          updateGroup: route.status === 'DISPATCHED' || routeVisitScheduleDay.status === 'Completed' || this.visitPlan.hasNotSyncedChanges ? false : !route.locked,      // drag items from one group to another
        }
      }
    });
  }

  private isActivityLocked(activity) {
    if (activity.jobId) {
      return !!this.jobsMap[activity.jobId]?.lockedRouteId;
    } else if (activity.jobIds?.length) {
      for (let id of activity.jobIds) {
        if (!!this.jobsMap[id]?.lockedRouteId) {
          return true;
        }
      }
      return false;
    }
  }

  private _getReTripItemsData(route, color) {
    const items = [];

    _.forEach(route.activities, (a, index: number) => {
      if (!!a.tripNumber && a.tripNumber > 1) {
        if ((!index) || ((route.activities[index - 1]?.tripNumber || 0) < a.tripNumber)) {
          const milisBefore = 30000;
          const activityEta = _.get(a, 'eta');

          items.push(
            {
              isRetrip: true,
              id: route.id + a.tripNumber,
              routeId: route.id,
              start: this.moment(activityEta - milisBefore),
              end: this.moment(activityEta - milisBefore),
              group: route.id,
              routeColor: color,
              style: `background-color: white; border-color: ${color}; color: ${color};`,
              className: 'trip',
              editable: false
            }
          )
        }
      }
    })

    return items;
  }


  private _getStartEndPointsContent(activity, routeColor) {
    const stopType = activity.type;
    const label = this.$filter('translate')(stopType === 'START' ? 'S' : 'E');
    return '<span class="br-body-2 font-weight-400 ' + label + '">' + label + '</span>'
      + '<div class="dot" style="background-color: #7E7E7E"></div>'
  }

  private _getStopContent(activity, relatedStops, warnings, color, includeRetrip?) {

    const stopType = activity.stopType || activity.type;
    const activityType = activity.type;
    const tripNumber = activity.tripNumber;
    const itemType = stopType || activityType;
    const isGroup = _.isEqual(activity.type, 'GROUP');

    let relationIcon;
    const relationDivs = document.createElement('div');
    if (relatedStops && relatedStops.length) {
      relationIcon = this.$linkIcon.cloneNode(true);
      relationIcon.classList.add('white');
      const routeIds = _.flatMap(relatedStops, function (r) {
        return r.routeIds;
      });

      relationDivs.appendChild(this._getRelatedRoutesIndicationDiv(routeIds));
    }

    const warningsDiv = document.createElement('div');
    let warnIcon;

    if (warnings && warnings.length) {
      warnIcon = this.$errorIcon.cloneNode(true);
      warnIcon.classList.add('white');
      const warningTypes = _.flatMap(warnings, (w) => {
        return this.$filter('translate')(w.type);
      });
      warningsDiv.classList.add('info-row');
      warningsDiv.appendChild(warnIcon);
      const span = document.createElement('span');
      _.forEach(warningTypes, function (w, i) {
        if (i + 1 < warningTypes.length) {
          w += ', '
        }
        span.textContent += w;
      })
      warningsDiv.appendChild(span);
    }

    let spanRow;
    if (!!activity?.tripNumber && includeRetrip) {
      spanRow = '<span class="trip-number-index">' + activity.tripNumber + '</span>'
    }

    let jobProgramTypeAlias;
    let activityAccountName;
    if (activity?.jobId && (activity.type !== 'START') && (activity.type !== 'END')) {
      const job = this.jobsMap[activity.jobId];
      jobProgramTypeAlias = this.programTypeAliasMap[job?.pricePlanProgramType] ? this.programTypeAliasMap[job?.pricePlanProgramType] : job.pricePlanProgramType.charAt(0);
      activityAccountName = job.accountDocumentName || job.accountName;
    }

    return isGroup ?
      '<div class="item-body br-caption-1 font-weight-800" style="background-color: ' + color + 20 + '">'
      + '<span class="text">' + this.$filter('translate')(itemType.charAt(0)) + '(' + activity.stopActivities.length + ') ' + activity.indexInRoute + '</span>'
      + (spanRow ? spanRow : '')
      + '</div>'
      + (relationIcon ? relationIcon.outerHTML : '')
      + (warnIcon ? warnIcon.outerHTML : '') :
      '<div class="item-body br-caption-1 font-weight-300" style="background-color: ' + color + 20 + '">'
      + '<span class="text font-weight-600">' + (activity.indexInRoute) + ' ' + escapeHtml(jobProgramTypeAlias) + '</span>' + ' ' + escapeHtml(activityAccountName)
      + (spanRow ? spanRow : '')
      + '</div>'

    // return isGroup ? '<span class="br-caption-2">' + this.$filter('translate')(itemType.charAt(0)) + '(' + activity.stopActivities.length + ') ' + activity.indexInRoute + '</span>'
    //   + (relationIcon ? relationIcon.outerHTML : '')
    //   + (warnIcon ? warnIcon.outerHTML : '') :
    //   '<span class="br-caption-2">' + this.$filter('translate')(itemType.charAt(0)) + ' ' + (activity.indexInRoute) + '</span>'
    //   + (relationIcon ? relationIcon.outerHTML : '')
    //   + (warnIcon ? warnIcon.outerHTML : '');
  }

  private _getStartEndTooltip(activity) {
    const routeColor = this._getRouteColor(activity.routeId);
    const stopType = activity.type;
    const depotId = _.get(activity, 'depotId');

    return '<div class="header-container">'
      + '<span class="br-body-2 font-weight-600" style="color: ' + routeColor + '">' + this.$filter('translate')(stopType) + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$depotIcon.outerHTML
      + '<span class="br-body-2 margin-left-5">' + escapeHtml(_.get(this.depotsMap, depotId + '.name', '---')) + '</span>'
      + '</div>'
      + '<div class="info-row">'
      + this.$locationIcon.outerHTML
      + '<span class="br-body-2 margin-left-5">' + escapeHtml(this.$filter('bringozAddress')(activity.address)) + '</span>'
      + '</div>'
  }


  private _getStopTooltip(activity, route, activityAnalysis?: VisitScheduleRouteActivityAnalysisModel, routeAnalysis?: VisitScheduleRouteAnalysisModel) {

    const routeColor = !!this.agentColorMap ? this.agentColorMap[route.resource.agentId] : this._getRouteColor(activity.routeId);

    const serviceTime = activity.detailedServiceTime?.generatedTotalTime;
    const depotId = _.get(activity, 'depotId');
    const originalTimeWindow = this.$filter('timeWindow')(activity);
    let originalTimeWindowUserTimezone = '';

    if (!!this.timezoneOffset) {
      const timeWindow = this.$filter('timeWindow')(activity, this.userZoneId);
      originalTimeWindowUserTimezone = '<div class="info-row">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-2">' + timeWindow + '</span>'
        + '</div>'
    }
    // const
    const activityType = activity.type;

    const defaultServiceTime = 60000;
    const activityServiceTimeInMili = _.get(activity, 'serviceTime', 5) * defaultServiceTime;
    const activityEta = _.get(activity, 'eta');
    const activityEtd = _.get(activity, 'etd', activityEta + activityServiceTimeInMili);

    const activityPurpose = activity.stopType || '---';
    const isStop = _.isEqual(activity.type, 'STOP');
    const isGroup = _.isEqual(activity.type, 'GROUP');
    // const isPoint = (!isStop && !isGroup && !_.get(activity, 'serviceTime'));
    const stopTimeWindow = this.$filter('timeWindow')({notBefore: activityEta, notAfter: activityEtd});

    let stopTimeWindowUserTimezone = '';

    let jobProgramTypeAlias = '';
    if ((activity?.jobId || activity?.jobIds) && (activity.type !== 'START') && (activity.type !== 'END')) {
      const jobIds = activity.jobIds || [activity.jobId]
      jobIds.forEach((i) => {
        const job = this.jobsMap?.[i];
        const jobProgramType = job?.pricePlanProgramType || '';
        if (jobProgramType && this.programTypeAliasMap?.[jobProgramType]) {
          jobProgramTypeAlias = jobProgramTypeAlias + this.programTypeAliasMap[jobProgramType];
        } else if (jobProgramType) {
          jobProgramTypeAlias = jobProgramTypeAlias + jobProgramType.charAt(0);
        }
      })
      // const job = this.jobsMap?.[activity.jobIds?.length ? activity.jobIds[0] : activity.jobId];
      // const jobProgramType = job?.pricePlanProgramType || '';
      // if (jobProgramType && this.programTypeAliasMap?.[jobProgramType]) {
      //   jobProgramTypeAlias = this.programTypeAliasMap[jobProgramType];
      // } else if (jobProgramType) {
      //   jobProgramTypeAlias = jobProgramType.charAt(0);
      // }
    }

    const details: VisitScheduleActivityDetailsModel = route.activityDetails?.find((ad: VisitScheduleActivityDetailsModel) => {
      return ad.activityId === activity.id;
    })

    let branchesRow = '';
    if (!!details?.branchReferences) {
      branchesRow = '<div class="info-row">'
        + this.$branchIcon.outerHTML
        + '<span class="br-body-1 margin-right-10">' + escapeHtml(this._getNames(_.map(details.branchReferences, 'name'), 3)) + '</span>'
        + '</div>'
    }

    let programTypeRow = '';
    if (!!jobProgramTypeAlias) {
      programTypeRow = '<div class="info-row">'
        + this.$programIcon.outerHTML
        + '<span class="br-body-2 activity-program-type">' + escapeHtml(jobProgramTypeAlias) + '</span>'
        + '</div>'
    }

    if (!!this.timezoneOffset) {
      const timeWindow = this.$filter('timeWindow')({notBefore: activityEta, notAfter: activityEtd}, this.userZoneId);
      stopTimeWindowUserTimezone = '<div class="info-row">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-2">' + timeWindow + '</span>'
        + '</div>'
    }

    let travelTimeRow = '';
    if (activity.travelTimeFromLastStopMillis) {
      travelTimeRow = '<div class="info-row">'
        + '<span class="br-body-2 margin-left-5 margin-right-5"> ' + this.$filter('translate')('Travel Time') + '</span>'
        + '<span class="br-body-2">' + this.$filter('bringozTimeConvert')(Math.abs(activity.travelTimeFromLastStopMillis), true) + '</span>'
        + '</div>'
    }

    let idleTimeRow = '';
    if (activity.notBefore > activityEta) {
      idleTimeRow = '<div class="info-row">'
        + '<span class="br-body-2 margin-left-5 margin-right-5"> ' + this.$filter('translate')('Idle Time') + '</span>'
        + '<span class="br-body-2">' + this.$filter('bringozTimeConvert')(Math.abs(activityEta - activity.notBefore), true) + '</span>'
        + '</div>'
    }

    let serviceTimeRow = '';
    if (!!serviceTime) {
      serviceTimeRow = '<div class="info-row">'
        + '<span class="br-body-2 margin-left-5 margin-right-5"> ' + this.$filter('translate')('Service Time') + '</span>'
        + '<span class="br-body-2">' + this.$filter('bringozTimeConvert')(serviceTime, true) + '</span>'
        + '</div>'
    }

    let risksSection = '';
    if (activityAnalysis?.risks?.length || routeAnalysis?.risks?.length) {
      risksSection = '<div class="risks-container">'
      // + '<span class="br-body-3 risks-header">' + this.$filter('translate')('Risks') + ':</span>'

      activityAnalysis?.risks?.forEach((r) => {
        risksSection += '<div class="info-row">'
          + this.$riskIcon.outerHTML
          + '<span class="br-body-2"> ' + this.$filter('translate')('VISIT_SCHEDULE_RISK.ROUTE_ACTIVITY.' + r) + '</span>'
          + '</div>'
      })

      routeAnalysis?.risks?.forEach((r) => {
        risksSection += '<div class="info-row">'
          + this.$riskIcon.outerHTML
          + '<span class="br-body-2"> ' + this.$filter('translate')('VISIT_SCHEDULE_RISK.ROUTE.' + r) + '</span>'
          + '</div>'
      })

      risksSection += '</div>';
    }

    // const barcodes = this.planningCommonService.getBarcodesString(activity);
    const activityPackageTotals = this.planningCommonService.getActivityPackageTotals(activity);
    // const spotsTotal = this.$filter('orderSpots')(activity.packages);
    // const relationDivs = document.createElement('div');
    // let tripNumberRow;
    //
    //
    // const warningsDiv = document.createElement('div');
    // let warnIcon;

    // const skillsDiv = document.createElement('div');
    // const skills = _.get(ctrl.jobsMap[activity.jobId], 'skills', []);
    //
    // if (skills && skills.length) {
    //   _.forEach(skills, function(s, i) {
    //     const skill = document.createElement('div');
    //     skill.classList.add('skill-tag');
    //
    //     const skillText = document.createElement('span');
    //     skillText.innerHTML = _getTranslatedSkill(s);
    //     skill.appendChild(skillText);
    //     skillsDiv.appendChild(skill);
    //   })
    // }


    const activityAddress = _.get(activity, 'stopActivities[0].address', activity.address);
    const activityAccount = _.get(activity, 'stopActivities[0].accountName', activity.accountName) || '---';
    const tooltipHeader = (isGroup ? this.$filter('translate')('Multi') + ' ' : '') + activityPurpose;

    return '<div class="header-container">'
      + '<span class="br-body-2 font-weight-600" style="color: ' + routeColor + '">' + tooltipHeader + '</span>'
      + '</div>'
      // + '<div class="info-row">'
      // + this.$locationIcon.outerHTML
      // + '<span class="br-body-2 margin-left-5">' + this.$filter('bringozAddress')(activityAddress) + '</span>'
      // + '</div>'
      + '<div class="info-row">'
      + this.$accountIcon.outerHTML
      + '<span class="br-body-2">' + escapeHtml(activityAccount) + '</span>'
      + '</div>'
      + branchesRow
      // + '<div class="info-row">'
      // + this.$depotIcon.outerHTML
      // + '<span class="br-body-2 margin-left-5">' + _.get(this.depotsMap, depotId + '.name', '---') + '</span>'
      // + '</div>'
      // + '<div class="info-row">'
      // + $skillsIcon.outerHTML
      // + skillsDiv.outerHTML
      // + '</div>'
      + '<div class="info-row">'
      + this.$originalTimeWindowIcon.outerHTML
      // + '<span class="br-body-2 margin-left-5">' + this.$filter('bringozDate')(activity.notBefore) + '</span>'
      + '<span class="br-body-2">' + originalTimeWindow + '</span>'
      + originalTimeWindowUserTimezone
      + '</div>'
      + '<div class="info-row">'
      + this.$timeWindowIcon.outerHTML
      + '<span class="br-body-2 margin-right-10">' + stopTimeWindow + '</span>'
      + stopTimeWindowUserTimezone
      + '</div>'
      + travelTimeRow
      + idleTimeRow
      + serviceTimeRow
      + programTypeRow
      + risksSection
    // + tripNumberRow
    // + warningsDiv.outerHTML
    // + '<div class="info-row margin-right-5">'
    // + this.$packageIcon.outerHTML
    // + '<span class="br-body-2 margin-right-5">' + _.get(activityPackageTotals, 'packages', '---') + '</span>'
    // + this.$weightIcon.outerHTML
    // + '<span class="br-body-2 margin-right-5">' + _.get(activityPackageTotals, 'weight', '---') + '</span>'
    // + this.$volumeIcon.outerHTML
    // + '<span class="br-body-2 margin-right-5">' + _.get(activityPackageTotals, 'volume', '---') + '</span>'
    // // + this.$spotsIcon.outerHTML
    // // + '<span class="br-body-2">' + spotsTotal + '</span>'
    // + '</div>'
    // + '<div class="info-row">'
    // + this.$barcodeIcon.outerHTML
    // + '<span class="br-body-2 margin-left-5">' + barcodes + '</span>'
    // + '</div>'
  }


  private _onClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  private _getTimelineActivityById(id) {

    if (!id) {
      return undefined;
    }

    const selectedItem = this.itemsDataSet.get({
      filter: (item) => {
        return item.id === id || item.activityId === id;
      }
    });
    return this.itemsDataSet.get(selectedItem[0] ? selectedItem[0].id : undefined)
  }

  private _getTimelineActivitiesByJobIds(jobIds) {

    let activities = [];
    if (!jobIds) {
      return [];
    }

    this.itemsDataSet?.forEach((item) => {
      if (item.jobIds?.length && item.jobIds.every(jobId => jobIds.includes(jobId))) {
        activities.push(item);
      }
    });
    return activities;
  }

  private _setGroupVisibilityByIds(ids) {

    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      group.visible = ids ? _.includes(ids, group.id) : true;
      // group.visible = (ids && ids.length) ?_.includes(ids, group.id) : true;
      updatedGroups.push(group);
    });

    this.timeline.setGroups(updatedGroups);
    this.fitTimeline();
  }

  private _getSpotsTotal(packages) {
    return this.$filter('orderSpots')(packages);
  }

  private _setInspectedItemsByIds(ids) {

    if (!ids) {
      ids = [];
    }

    const updatedItems = [];

    this.itemsDataSet.forEach((item) => {
      const isBackground = item.type === 'background';
      const isPoint = item.point === 'point';
      const isEnabled = !ids.length || (_.includes(ids, item.stopId) || _.intersection(ids, _.get(item, 'stopIds', [])).length > 0);
      // item.className = isPoint ? 'point' : (isBackground ? '' : 'stop');


      if (isEnabled) {
        item.className = item.className.replace("disabled", "");
      } else {
        item.className += ' disabled';
      }

      // const style = 'background-color: ' + item.routeColor + '!important;';
      // style += !ids.length || (_.includes(ids, item.stopId) || _.intersection(ids, _.get(item, 'stopIds', [])).length > 0) ? 'opacity: 1' : 'opacity: 0.3';
      // item.style = style;
      updatedItems.push(item);
    });

    this.itemsDataSet.update(updatedItems);

    // timeline.setItems(updatedItems);
  }

  private _canItemMove(item) {

    const movingToRoute = _.find(this.routes, (r) => {
      return r.id === item.group;
    })

    if (item.activityType === 'GROUP' && item.stopIds.length < 1) {
      return false;
    }

    if (item.activityType !== 'GROUP' && !item.stopId) {
      return false;
    }

    if (movingToRoute) {
      const resourceSkills = _.get(movingToRoute, 'resource.allocationSkills', []);
      const itemSkill = item.purpose === 'Operation' ? 'Merchandise' : 'Delivery';
      if (!_.includes(resourceSkills, itemSkill)) {
        const stopType = this.$filter('translate')('SKILLS.' + itemSkill);
        const routeType = this.$filter('translate')('SKILLS.' + resourceSkills[0]);
        this.planningAlertsService.stopTypeToRouteRejectionInfo(stopType, routeType);
        return false;
      }
    }

    const orderedItems = _.filter(this.timeline.components[3].groups[item.group].orderedItems.byStart, (orderedItem) => {
      return !!orderedItem.data.activityType;
    });

    const itemPurpose = item.purpose;
    const itemIndex = _.findIndex(orderedItems, (orderedItem: any) => {
      return orderedItem.data.activityId === item.activityId;
    });

    const movedActivityOriginalRoute = _.find(this.routes, (r) => {
      const ids = _.map(r.activities, 'id');
      return _.includes(ids, item.id);
    })
    const activityOriginalIndex = _.findIndex(movedActivityOriginalRoute.activities, (a: any) => {
      return a.id === item.id;
    })

    if (_.isEqual(movedActivityOriginalRoute.id, item.group) &&
      _.isEqual(activityOriginalIndex, itemIndex)) {
      return false;
    }

    const parallelIndex = _.findIndex(orderedItems, (task: TaskModel) => {
      return (task.id !== item.id) && !!_.intersection(_.get(task, 'data.jobIds', []), _.get(item, 'jobIds', [])).length;
    });
    if (parallelIndex < 0) {
      return true;
    } else {
      return itemPurpose === 'Pickup' ? (itemIndex < parallelIndex) : (parallelIndex < itemIndex);
    }
  }

  private _canLeftoversAddToRoute(leftovers, toRouteId) {
    const route = _.find(this.routes, (r) => {
      return r.id === toRouteId;
    })
    let canAddBulk = true;
    _.forEach(leftovers, (l) => {
      const resourceSkills = _.get(route, 'resource.allocationSkills', []);
      const leftoverSkill = _.get(l, 'skills.length') ? l.skills[0] : (l.jobType === 'Operation' ? 'Merchandise' : 'Delivery');

      if (!_.includes(resourceSkills, leftoverSkill)) {
        const stopType = this.$filter('translate')('SKILLS.' + leftoverSkill);
        const routeType = this.$filter('translate')('SKILLS.' + resourceSkills[0]);
        this.planningAlertsService.stopTypeToRouteRejectionInfo(stopType, routeType);
        canAddBulk = false;
        return false;
      }
    })
    return canAddBulk;
  }

  private _createBlockButton(id, locked, onClick) {
    const blockButton = this.$lockIcon.cloneNode(true);
    blockButton.src = locked ? this.iconsUrl.locked : this.iconsUrl.unlocked;

    blockButton.id = id;
    blockButton.classList.add("md-icon-button", "block-button", "cursor-pointer", "margin-left-5");
    blockButton.locked = locked;
    // blockButton.style.opacity = locked ? '1' : '0.5';

    // Button Event Listener
    blockButton.addEventListener("click", () => {
      this._onClicked().then(() => {
        onClick();
      });
    }, {passive: true});

    return blockButton;
  }

  private _initTimelineEventListeners() {

    const visLeft = document.getElementsByClassName('vis-left')[0];
    const labelSetDiv = document.getElementsByClassName('vis-labelset')[0];
    // const resizerWidth = parseInt($(visLeft).css('borderRightWidth'));
    let visLeftClientReact;
    let mouseDown = false;

    /////////////////////
    // Timeline Events //
    /////////////////////

    // Hover
    // this.timeline.on('mouseOver', (props) => {
    //   if (props.item) {
    //     this._onClicked().then(() => {
    //
    //       this.onActivityHover({id: props.item, $event: props.event});
    //     });
    //   }
    // });

    // DoubleClick Event
    this.timeline.on('doubleClick', (properties) => {
      if (!!_.get(properties, 'item')) {
        this._onClicked().then(() => {
          this.onZoomActivity({id: properties.item});
        });
      }
    });

    // On Item Click
    this.timeline.on('select', (properties) => {
      this._onClicked().then(() => {
        const selectedActivity = this._getTimelineActivityById(properties.items[0]);
        // this.onActivitySelection({jobIds: _.get(selectedActivity, 'jobIds')});

        if (selectedActivity && this.inspectedStopIds && this.inspectedStopIds.length) {
          const activityType = selectedActivity.activityType;
          const stopIds = activityType === 'STOP' ?
            [_.get(selectedActivity, 'stopId')] :
            _.get(selectedActivity, 'stopIds', []);
          const inspectedStopIds = _.map(selectedActivity.relatedStops, 'id').concat(stopIds);
          this.onInspectedStopIdsChange({ids: inspectedStopIds});
        }

        // properties.event.preventDefault();
      });
    });

    // On Timeline Click
    // timeline.on('click', function (properties) {
    //     _onClicked().then(function() {
    //         if (ctrl.inspectedStopIds && ctrl.inspectedStopIds.length && !properties.item) {
    //             ctrl.onInspectedStopIdsChange({ids: []});
    //         }
    //     });
    // });

    // Right Click
    this.timeline.on('contextmenu', (props) => {
      if (props.item) {
        const selectedActivity = this._getTimelineActivityById(props.item);
        if (selectedActivity && this.canEdit) {
          const activityType = selectedActivity.activityType;
          if (activityType === 'STOP' || activityType === 'GROUP') {

            const stopIds = activityType === 'STOP' ?
              [_.get(selectedActivity, 'stopId')] :
              _.get(selectedActivity, 'stopIds', []);

            this._onClicked().then(() => {
              this.onActivityRightClick({
                routeId: _.get(selectedActivity, 'routeId'),
                jobIds: selectedActivity.jobIds,
                stopIds: stopIds,
                relations: selectedActivity.relatedStops,
                $event: props.event
              })
            });
          }
        }
        // if (selectedActivity && ctrl.canEdit &&
        //     (selectedActivity.activityType === 'STOP' || selectedActivity.activityType === 'GROUP')) {
        //     _onClicked().then(function() {
        //         var stopIds =
        //         ctrl.onActivityRightClick({
        //             routeId: _.get(selectedActivity, 'routeId'),
        //             jobId:  _.get(selectedActivity, 'jobId'),
        //             stopId: _.get(selectedActivity, 'stopId'),
        //             stopIds: _.get(selectedActivity, 'stopIds'),
        //             hasRelations: selectedActivity.relatedStops.length > 0,
        //             $event: props.event
        //         })
        //     });
        // }
      }
      props.event.preventDefault();
    });

    // // Mouse Down
    // timeline.on('mouseDown', function (props) {
    //   visLeftClientReact = visLeft.getBoundingClientRect();
    //   var resizerFrom = visLeftClientReact.x + visLeftClientReact.width - resizerWidth;
    //   var resizerTo = visLeftClientReact.x + visLeftClientReact.width;
    //
    //   if (props.event.pageX >= resizerFrom && props.event.pageX <= resizerTo) {
    //     mouseDown = true;
    //   }
    // });
    //
    // // Mouse Move
    // timeline.on('mouseMove', function (props) {
    //   if (mouseDown) {
    //     var px = (props.event.pageX - visLeftClientReact.x);
    //     visLeft.style.width = px + 'px';
    //     tableHeaderDivRef.style.width = (px - resizerWidth) + 'px';
    //     timeline.redraw();
    //   }
    // });
    //
    // // Mouse Up
    // timeline.on('mouseUp', function (props) {
    //   mouseDown = false;
    // });
    //
    // ///////////////////
    // // Custom Events //
    // ///////////////////
    //
    // // Sync Scroll - Table Header & Table Body
    // labelSetDiv.addEventListener("scroll", function (e) {
    //   tableHeaderDivRef.scrollLeft = labelSetDiv.scrollLeft;
    // }, {passive: true});
  }

  private _updateTimelineSelectedTassStyle(currentSelectedId, previousSelectedId) {
    const itemsToUpdate = [];

    this.itemsDataSet.forEach((item) => {
      if (currentSelectedId === _.get(item, 'id')) {
        item.style = `background-color: ${item.routeColor}; border-color: ${item.routeColor}; color: white;`;
        itemsToUpdate.push(item);
      } else if (previousSelectedId === _.get(item, 'id')) {
        item.style = `background-color: white; border-color: ${item.routeColor}; color: ${item.routeColor};`;
        itemsToUpdate.push(item);
      }
    });
    this.itemsDataSet.update(itemsToUpdate);
  }

  private _updateTimelineSelectedActivitesStyle(currentSelectedIds, previousSelectedIds) {
    const itemsToUpdate = [];

    if (!this.itemsDataSet) {
      return;
    }

    this.itemsDataSet.forEach((item) => {
      if (currentSelectedIds?.includes(_.get(item, 'id'))) {
        item.style = `background-color: ${item.routeColor}; border-color: ${item.routeColor}; color: white;`;
        itemsToUpdate.push(item);
      } else if (previousSelectedIds?.includes(_.get(item, 'id'))) {
        item.style = `background-color: white; border-color: ${item.routeColor}; color: ${item.routeColor};`;
        itemsToUpdate.push(item);
      }
    });
    this.itemsDataSet.update(itemsToUpdate);
  }

  private _getResourceItemsData(resources) {
    let items = [];
    _.forEach(resources, (resource) => {
      if (resource.scheduleType === 'Availability') {
        const resourceRoute = this._getRoutesByResourceId(resource.id);

        if (!!resourceRoute) {
          items.push(this._parseResourceToItem(resource, resourceRoute));
        }
      }
    });

    return items;
  }

  private _parseResourceToItem(resource: VisitScheduleResourceModel, resourceRoute) {
    // const route = this._getRoutesByResourceId(resource.id);

    const routeVisitScheduleDay = this.visitScheduleDays.find(vsd => vsd.id === resource.visitScheduleDayId);

    const isDisabled = resource.disabled || resourceRoute?.status === 'DISPATCHED' || routeVisitScheduleDay?.status === 'Completed';

    return {
      itemType: 'RESOURCE',
      scheduleType: resource.scheduleType,
      start: this.moment(resource.startTime),
      end: this.moment(resource.endTime),
      id: resource.id,
      // id: item.agentSchedule.id + ':Tag:' + item.agentId + ':Date:' + this.moment(item.agentSchedule.schedule.startTime).format("DD-MM-YYYY"),
      group: resourceRoute.id,
      agentId: resource.agentId,
      ref: resource,
      editable: {
        add: false,                          // add new items by double tapping
        updateTime: false,                   // drag items horizontally
        updateGroup: false,              // drag items from one group to another
        remove: false,                 // delete an item by tapping the delete button top right
        overrideItems: true          // allow these options to override item.editable
      },
      selectable: true,
      // title: this.bringozTimelineService.getShiftTimelineItemTooltip(resource),
      content: undefined,
      className: `schedule ${resource.scheduleType} ${isDisabled ? 'Disabled' : ''}`,
      // type: 'background',
      // style: 'background: ' + color
    }
  }

  private _getRoutesByResourceId(resourceId: string) {
    return _.find(this.routes, (r) => {
      return r.resourceId === resourceId;
    });
  }

  private _getNames(names: string[], maxCount?: number) {
    let string = '';
    if (!names || !names.length) {
      return '';
    }

    let addedCount = 0;
    _.forEach(names, (name, i) => {
      addedCount +=1;
      string += name;
      if (i + 1 < names.length && i < (maxCount || 0)) {
        string += ', '
      }
    });

    if (!!maxCount && addedCount < names.length) {
      string += ` +${names.length - addedCount}`
    }
    return string;
  }

  $onDestroy() {
    if (this.container) {
      this.container.removeEventListener('click', this._onContainerClick);
      this.container = null;
    }
    if (this.timeline) {
      this.timeline.destroy();
      this.timeline = null;
    }
    if (this.itemsDataSet) {
      this.itemsDataSet.clear();
      this.itemsDataSet = null;
    }
    if (this.groupsDataSet) {
      this.groupsDataSet.clear();
      this.groupsDataSet = null;
    }
  }

}

angular
  .module('bringoz.admin.scheduling-project')
  .component('visitPlanRoutesTimeline', {
    bindings: {
      visitPlan: '<?',
      visitScheduleDays: '<?',
      from: '<',
      to: '<',
      allRoutes: '<',
      depotsMap: '<',
      mainRoutes: '<',
      analysis: '<?',
      routes: '<',
      jobs: '<?',
      queryString: '<?',
      draftAnalysis: '<?',
      draft: '<',
      selectedItemId: '<',
      selectedJobIds: '<?',
      canEdit: '<',
      displayPrice: '<',
      hiddenRouteIds: '<?',
      hideLockedRoutes: '<?',
      inspectedStopIds: '<',
      isGroupedRoutes: '<?',
      visibleResourceAllocationSkills: '<?',
      isValidateRouteVehicles: '<?',
      offset: '<?',
      limit: '<?',
      doFit: '<?',
      agentColorMap: '<?',
      programTypeAliasMap: '<?',
      resources: '<?',
      onFit: '&',
      onAddStopsToRoute: '&',
      onToggleRoute: '&',
      onRouteInfoClick: '&',
      onToggleHiddenRoutes: '&',
      onRoutesChange: '&',
      onLockRouteChange: '&',
      onInspectedStopIdsChange: '&',
      onZoomActivity: '&',
      onActivitySelection: '&',
      onActivityHover: '&',
      onActivityRightClick: '&',
      onMoveItem: '&',
      onRecalcRoute: '&',
      onDeleteRoute: '&',
      onDispatchRoute: '&',
      onChangeRouteResource: '&',
      onEditRoutes: '&',
      onToggleHideLockedRoutes: '&',
      onQueryChange: '&',
      onFiltersChange: '&',
      onPaginationBrowse: '&',
      onPaginationChange: '&'
    },
    template: require('./visit-plan-routes-timeline.html').default,
    controller: VisitPlanRoutesTimelineComponent
  });
